module.exports = __webpack_public_path__ + "static/media/Selfie_With_Passport.c6383daf.png";